import React from "react";
import { Link } from "react-router-dom";
import { IMAGE_TOOLS } from "./playgroundTools";

export default function PlaygroundHub() {
  return (
    <div className="-mx-3 min-h-screen bg-white">
      <div className="mx-auto max-w-4xl px-3 py-3 md:px-4 md:py-5">
        <div className="pt-2 text-center mb-6">
          <h1
            className="inline-block pb-1 text-3xl leading-tight md:text-4xl font-extrabold mb-3"
            style={{
              background: "linear-gradient(90deg, #1e293b 0%, #334155 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            My Challenge Canada Playground
          </h1>
          <p className="text-base md:text-lg" style={{ color: "#64748b" }}>
            Play, create, and discover new ways to get more from your challenges.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-x-4 gap-y-6 md:grid-cols-5 md:gap-x-5 md:gap-y-8 md:px-8 lg:px-12">
          {IMAGE_TOOLS.map((tool) => (
            <ToolCard key={tool.id} tool={tool} />
          ))}
        </div>
      </div>
    </div>
  );
}

function ToolCard({ tool }) {
  const card = (
    <div className={`group text-center ${tool.comingSoon ? "opacity-55" : "cursor-pointer"}`}>
      <div
        className={`relative mx-auto flex aspect-square w-full items-center justify-center overflow-hidden rounded-[22%] border shadow-md transition-all duration-200 md:max-w-[120px] ${
          tool.comingSoon
            ? "border-slate-300 bg-gradient-to-br from-slate-100 to-slate-300"
            : "border-indigo-200 bg-gradient-to-br from-indigo-50 via-violet-100 to-blue-200 group-hover:-translate-y-1 group-hover:scale-[1.03] group-hover:shadow-xl"
        }`}
      >
        <span className="text-4xl drop-shadow-sm sm:text-5xl md:text-6xl" aria-hidden="true">
          {tool.icon}
        </span>
        {tool.comingSoon && (
          <span className="absolute bottom-2 rounded-full bg-slate-700/85 px-2 py-0.5 text-[8px] font-bold uppercase tracking-wide text-white sm:text-[9px]">
            Soon
          </span>
        )}
      </div>
      <h3 className="mx-auto mb-0 mt-2 max-w-[150px] text-xs font-bold leading-tight text-slate-700 sm:text-sm">
        {tool.title}
      </h3>
    </div>
  );

  if (tool.comingSoon) return card;
  if (tool.external) {
    return (
      <a href={tool.path} target="_blank" rel="noopener noreferrer" className="no-underline">
        {card}
      </a>
    );
  }

  return (
    <Link to={tool.path} className="no-underline">
      {card}
    </Link>
  );
}
